import React, { Component } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import fetch from 'cross-fetch';
import TextField from '../bits/TextField.jsx';

// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : isoCode;
}

class CountrySelect extends Component {
  state = {
    isLoading: true,
    selectedCountryCode: null,
    inputValue: '',
    countries: [
      { code: 'VU', label: 'Vanuatu', phone: '678' },
      { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
    ],
  };

  componentDidMount() {
    // Load countries list
    // Populate selected country if props.useGeoDefault is true
    this.loadCountriesList();
  }

  loadCountriesList = () => fetch('/countries', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Unable to load countries');
      }

      return response.json();
    })
    .then((json) => {
      this.setState({
        countries: json.availableCountries,
        isLoading: false,
      });

      if (this.props.defaultToGeoCountry) {
        this.setCountryCode(json.geoCountryCode || 'US');
      }
    })
    .catch((error) => {
      this.setState({
        errorMsg: error.message,
        isLoading: false,
      });

      throw error;
    });

  handleCountryChange = (event, newValue) => {
    const selectedCountryCode = newValue && newValue.code ? newValue.code : null;
    this.setCountryCode(selectedCountryCode);
  }

  setCountryCode = (selectedCountryCode) => {
    this.setState({ selectedCountryCode });
    this.props.onChange(selectedCountryCode);
  }

  render() {
    const { label } = this.props;

    return (
      <Autocomplete
        id="country-select-demo"
        value={this.state.countries.find(e => e.code === this.state.selectedCountryCode) || null}
        onChange={this.handleCountryChange}
        inputValue={this.state.inputValue}
        onInputChange={(event, newInputValue) => {
          this.setState({ inputValue: newInputValue });
        }}
        options={this.state.countries}
        autoHighlight
        getOptionLabel={option => option.label || ''}
        renderOption={option => (
          <React.Fragment>
            <span>{countryToFlag(option.code)} </span>
            {option.label}
          </React.Fragment>
        )}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            margin="normal"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            }}
          />
        )}
      />
    );
  }
}

CountrySelect.propTypes = {
  defaultToGeoCountry: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string.isRequired,
};

export default CountrySelect;
